// extracted by mini-css-extract-plugin
module.exports = {"inner":"LeftDrawer_inner__38V8g","content":"LeftDrawer_content__2bQF9"};